<template>
    <div>
        <div v-if="!user">Loading...</div>
        <div v-else>
            <div class="col-6 mb-10">
                <button
                    class="btn btn-sm btn-danger"
                    @click.prevent="transactionModal"
                >
                    Create Transaction
                </button>
            </div class="block-content">
                <div class="col-sm-12 table-responsive">
                    <table
                        class="table table-striped table-vcenter"
                    >
                        <thead>
                            <tr role="row">
                                <th class="text-center" tabindex="0">
                                    #
                                </th>

                                <th class="text-capitalize">Transaction ID</th>
                                <th style="width: 100px;" class="text-capitalize">Transaction Date</th>
                                <th class="text-capitalize">
                                    Sender's Account
                                </th>
                                <th class="text-capitalize">
                                    Sender's Fullname
                                </th>
                                <th class="text-capitalize">
                                    Receiver's name
                                </th>
                                <th class="text-capitalize">
                                    Destination Account
                                </th>
                                <th class="text-capitalize">
                                    Amount
                                </th>
                                <th class="text-capitalize">
                                    Status
                                </th>
                                <th class="text-capitalize">
                                   Transaction Description
                                </th>
                                <th class="text-capitalize">
                                    Debit/Credit
                                </th>
                                <th class="text-capitalize">
                                    Transaction Type
                                </th>
                                <th class="text-center text-capitalize">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                role="row"
                                class="odd"
                                v-for="(transaction,
                                index) in user.transactions"
                            >
                                <td class="text-center sorting_1">
                                    {{ index + 1 }}
                                </td>
                                <td>
                                    {{ transaction.reference_id }}
                                </td>
                                <td>
                                    {{ transaction.when }}
                                </td>
                                <td>
                                    {{ transaction.sender_account }}
                                </td>
                                <td>
                                    {{ transaction.sender_name }}
                                </td>
                                <td>
                                    {{ transaction.receiver_name }}
                                </td>
                                <td>
                                    {{ transaction.receiver_account }}
                                </td>

                                <td>
                                    {{ transaction.curr_symbol
                                    }}{{ transaction.amount }}
                                </td>

                                <td>
                                    <span
                                        class="text-warning"
                                        v-if="transaction.status == 0"
                                        >Pending</span
                                    >
                                    <span class="text-success" v-else
                                        >Success</span
                                    >
                                </td>
                                <td>{{ transaction.description }}</td>
                                <td>
                                    <span
                                        class="text-danger"
                                        v-if="transaction.is_credit == 0"
                                        >DEBIT</span
                                    >
                                    <span class="text-success" v-else
                                        >CREDIT</span
                                    >
                                </td>
                                <td class="text-uppercase"> {{ transaction.trans_option }} Transfer</td>

                                <td>
                                    <div class="btn-group">
                                        <button v-if="transaction.status"
                                            type="button"
                                            class="btn btn-sm btn-danger mr-2"
                                            data-toggle="tooltip"
                                            title="Edit"
                                            @click.prevent="updateStatus(transaction.id)"
                                        > UnApprove

                                        </button>
                                        <button v-else
                                            type="button"
                                            class="btn btn-sm btn-success mr-2"
                                            data-toggle="tooltip"
                                            title="Edit"
                                            @click.prevent="updateStatus(transaction.id)"
                                        > Approve

                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-info"
                                            data-toggle="tooltip"
                                            title="Edit"
                                            @click.prevent="editModal(transaction)"
                                        >
                                            <i class="fa fa-edit"></i>
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-danger"
                                            data-toggle="tooltip"
                                            title="Delete"
                                            @click.prevent="
                                                deleteTransaction(transaction.id)
                                            "
                                        >
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>


            <!-- transactions modal  -->
            <div
                class="modal fade"
                id="modal-transactions"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-fadein"
                style="display: none;"
                aria-hidden="true"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="card-title">Create Transaction</h3>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <!-- Beginning of the form -->
                        <form @submit.prevent="createTransaction">
                            <div class="modal-body">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="form-group row">
                                            <div class="col-lg-6">
                                                <label for="account"
                                                    >Sender Account
                                                    Number</label
                                                >
                                                <input
                                                    id="account"
                                                    type="text"
                                                    class="form-control"
                                                    disabled
                                                    autocomplete="phone"
                                                    v-model="user.account"
                                                />
                                            </div>
                                            <div class="col-lg-6">
                                                <label for="fullname"
                                                    >Sender Fullname</label
                                                >
                                                <input
                                                    id="fullname"
                                                    name="lastname"
                                                    type="text"
                                                    disabled
                                                    class="form-control"
                                                    v-model="
                                                        user.first_name +
                                                            ' ' +
                                                            user.last_name
                                                    "
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-lg-6">
                                                <label for="receiver_name"
                                                    >Receiver's Fullname</label
                                                >
                                                <input
                                                    id="receiver_name"
                                                    name="receiver_name"
                                                    type="text"
                                                    class="form-control"
                                                    v-model="receiver_name"
                                                />
                                            </div>
                                            <div class="col-lg-6">
                                                <label for="receiver_account"
                                                    >Receiver's Account
                                                    Number</label
                                                >
                                                <input
                                                    id="receiver_account"
                                                    type="text"
                                                    class="form-control"
                                                    autocomplete="phone"
                                                    v-model="receiver_account"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-lg-6">
                                                <label for="trans_option"
                                                    >Fund transfer type</label
                                                >
                                                <select
                                                    name="trans_option"
                                                    id="trans_option"
                                                    class="form-control"
                                                    required
                                                    v-model="is_credit"
                                                >
                                                    <option value="1"
                                                        >Credit</option
                                                    >
                                                    <option value="0"
                                                        >Debit</option
                                                    >
                                                </select>
                                            </div>
                                            <div class="col-lg-6">
                                                <label for="bank_name"
                                                    >Bank Name</label
                                                >
                                                <input
                                                    id="bank_name"
                                                    type="text"
                                                    class="form-control"
                                                    v-model="bank_name"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-lg-6">
                                                <label for="curr"
                                                    >Currency</label
                                                >
                                                <select
                                                    name="curr"
                                                    id="curr"
                                                    class="form-control"
                                                    required=""
                                                    v-model="currency"
                                                >
                                                    <option disabled=""
                                                        >--- Choose Currency
                                                        ---</option
                                                    >
                                                    <option value="1"
                                                        >Euro (€)</option
                                                    >
                                                    <option value="2"
                                                        >Pounds (£)</option
                                                    >
                                                    <option value="3"
                                                        >Australian dollar
                                                        ($)</option
                                                    >
                                                    <option value="4"
                                                        >New Zealand dollar
                                                        ($)</option
                                                    >
                                                    <option value="5"
                                                        >Canadian dollar
                                                        ($)</option
                                                    >
                                                    <option value="6"
                                                        >Japanese yen
                                                        (¥)</option
                                                    >
                                                    <option value="7"
                                                        >Swiss franc (₣)</option
                                                    >
                                                    <option value="8"
                                                        >United States Dollar
                                                        ($)</option
                                                    >
                                                </select>
                                            </div>
                                            <div class="col-lg-6">
                                                <label for="amount"
                                                    >Amount</label
                                                >
                                                <input
                                                    id="amount"
                                                    type="text"
                                                    class="form-control"
                                                    autocomplete="amount"
                                                    v-model="amount"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-lg-6">
                                                <label for="trans_option"
                                                    >Fund transfer option</label
                                                >
                                                <select
                                                    name="trans_option"
                                                    id="trans_option"
                                                    class="form-control"
                                                    required
                                                    v-model="trans_option"
                                                >
                                                    <option
                                                        disabled=""
                                                        selected=""
                                                        >Select Option</option
                                                    >
                                                    <option
                                                        value="international"
                                                        >International
                                                        Transfer</option
                                                    >
                                                    <option value="domestic"
                                                        >Domestic
                                                        Transfer</option
                                                    >
                                                    <option value="local"
                                                        >Local Transfer</option
                                                    >
                                                </select>
                                            </div>

                                            <div class="col-lg-6">
                                                <label for="date"
                                                    >Transaction Date</label
                                                >
                                                <input
                                                    v-model="date"
                                                    type="date"
                                                    class="js-datepicker form-control"
                                                    id="date"
                                                    name="example-datepicker3"
                                                    placeholder="dd-mm-yyyy"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-lg-12">
                                                <label for="description"
                                                    >Transfer Description</label
                                                >
                                                <textarea
                                                    v-model="description"
                                                    name="desc"
                                                    class="form-control"
                                                    placeholder=""
                                                >
                                                </textarea>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div
                                                v-if="processing"
                                                class="col-6 col-md-3"
                                            >
                                                <i
                                                    class="fa fa-2x fa-cog fa-spin text-primary"
                                                ></i>
                                            </div>
                                            <div class="col-md-9" v-else>
                                                <button
                                                    type="submit"
                                                    class="btn btn-lg btn-outline-info mb-2"
                                                >
                                                    Send
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- transactions modal ends  -->

            <!-- transaction edit modal  -->
            <div
                class="modal fade"
                id="modal-edit"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-fadein"
                style="display: none;"
                aria-hidden="true"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="card-title">Update Transaction</h3>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <!-- Beginning of the form -->
                        <form @submit.prevent="updateTransaction">
                            <div class="modal-body">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="form-group row">
                                            <div class="col-lg-6">
                                                <label for="account"
                                                    >Sender Account
                                                    Number</label
                                                >
                                                <input
                                                    id="account"
                                                    type="text"
                                                    class="form-control"
                                                    disabled
                                                    autocomplete="phone"
                                                    v-model="current_txn.sender_account"
                                                />
                                            </div>
                                            <div class="col-lg-6">
                                                <label for="fullname"
                                                    >Sender Fullname</label
                                                >
                                                <input
                                                    id="fullname"
                                                    name="lastname"
                                                    type="text"
                                                    disabled
                                                    class="form-control"
                                                    v-model="
                                                        current_txn.sender_name
                                                    "
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-lg-6">
                                                <label for="receiver_name"
                                                    >Receiver's Fullname</label
                                                >
                                                <input
                                                    id="receiver_name"
                                                    name="receiver_name"
                                                    type="text"
                                                    class="form-control"
                                                    v-model="current_txn.receiver_name"
                                                />
                                            </div>
                                            <div class="col-lg-6">
                                                <label for="receiver_account"
                                                    >Receiver's Account
                                                    Number</label
                                                >
                                                <input
                                                    id="receiver_account"
                                                    type="text"
                                                    class="form-control"
                                                    autocomplete="phone"
                                                    v-model="current_txn.receiver_account"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-lg-6">
                                                <label for="trans_option"
                                                    >Fund transfer type</label
                                                >
                                                <select
                                                    name="trans_option"
                                                    id="trans_option"
                                                    class="form-control"
                                                    required
                                                    v-model="current_txn.is_credit"
                                                >
                                                    <option value="1"
                                                        >Credit</option
                                                    >
                                                    <option value="0"
                                                        >Debit</option
                                                    >
                                                </select>
                                            </div>
                                            <div class="col-lg-6">
                                                <label for="bank_name"
                                                    >Bank Name</label
                                                >
                                                <input
                                                    id="bank_name"
                                                    type="text"
                                                    class="form-control"
                                                    v-model="current_txn.bank_name"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-lg-6">
                                                <label for="curr"
                                                    >Currency</label
                                                >
                                                <select
                                                    name="curr"
                                                    id="curr"
                                                    class="form-control"
                                                    required=""
                                                    v-model="current_txn.currency"
                                                >
                                                    <option disabled=""
                                                        >--- Choose Currency
                                                        ---</option
                                                    >
                                                    <option value="1"
                                                        >Euro (€)</option
                                                    >
                                                    <option value="2"
                                                        >Pounds (£)</option
                                                    >
                                                    <option value="3"
                                                        >Australian dollar
                                                        ($)</option
                                                    >
                                                    <option value="4"
                                                        >New Zealand dollar
                                                        ($)</option
                                                    >
                                                    <option value="5"
                                                        >Canadian dollar
                                                        ($)</option
                                                    >
                                                    <option value="6"
                                                        >Japanese yen
                                                        (¥)</option
                                                    >
                                                    <option value="7"
                                                        >Swiss franc (₣)</option
                                                    >
                                                    <option value="8"
                                                        >United States Dollar
                                                        ($)</option
                                                    >
                                                </select>
                                            </div>
                                            <div class="col-lg-6">
                                                <label for="amount"
                                                    >Amount</label
                                                >
                                                <input
                                                    id="amount"
                                                    type="text"
                                                    class="form-control"
                                                    autocomplete="amount"
                                                    v-model="current_txn.amount"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-lg-6">
                                                <label for="trans_option"
                                                    >Fund transfer option</label
                                                >
                                                <select
                                                    name="trans_option"
                                                    id="trans_option"
                                                    class="form-control"
                                                    required
                                                    v-model="current_txn.trans_option"
                                                >
                                                    <option
                                                        disabled=""
                                                        selected=""
                                                        >Select Option</option
                                                    >
                                                    <option
                                                        value="international"
                                                        >International
                                                        Transfer</option
                                                    >
                                                    <option value="domestic"
                                                        >Domestic
                                                        Transfer</option
                                                    >
                                                    <option value="local"
                                                        >Local Transfer</option
                                                    >
                                                </select>
                                            </div>

                                            <div class="col-lg-6">
                                                <label for="date"
                                                    >Transaction Date</label
                                                >

                                                <input
                                                v-model="current_txn.date2"
                                                    type="date"
                                                    class="js-datepicker form-control"
                                                    id="date"
                                                    name="example-datepicker3"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-lg-12">
                                                <label for="description"
                                                    >Transfer Description</label
                                                >
                                                <textarea
                                                    v-model="current_txn.description"
                                                    name="desc"
                                                    class="form-control"
                                                    placeholder=""
                                                >
                                                </textarea>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div
                                                v-if="processing"
                                                class="col-6 col-md-3"
                                            >
                                                <i
                                                    class="fa fa-2x fa-cog fa-spin text-primary"
                                                ></i>
                                            </div>
                                            <div class="col-md-9" v-else>
                                                <button
                                                    type="submit"
                                                    class="btn btn-lg btn-danger mb-2"
                                                >
                                                    Update
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- transactions modal ends  -->
        </div>
    </div>
</template>
<script>
import { RepositoryFactory } from "../repository/RepositoryFactory";
const UsersRepository = RepositoryFactory.get("users");
export default {
    props: {
        user: Object
    },
    data() {
        return {
            date: "",
            amount: 0,
            description: "",
            trans_option: "international",
            receiver_name: "",
            currency: 8,
            receiver_account: "",
            is_credit: 1,
            bank_name: "",
            account: "balance",
            type: 1,
            processing: false,
            current_txn:{}
        };
    },
    methods: {
        editModal(txn){
            this.current_txn = txn;
            $('#modal-edit').modal('show')
        },
        async getTransactions() {
            this.$emit("refresh");
        },
        async updateStatus(id){
            await UsersRepository.adminUpdateTransactionStatus(id);
            this.refresh();
        },
        async updateTransaction(){
            try {
                this.processing = true;
                let data = this.current_txn;
                console.log(data)
                await UsersRepository.adminUpdateTransaction(this.current_txn.id, data);
                $('#modal-edit').modal('hide')
                this.processing = false;
            this.refresh();
             return toast.fire({
                        type: "success",
                        title: "Transaction updated successfully"
                    });
            } catch (error) {
                this.processing = false;
                return toast.fire({
                        type: "error",
                        title: "Something went wrong"
                    });
            }
        },
        deleteTransaction(id){
               swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!"
            }).then(async result => {
                // Send request to the server
                if (result.value) {
                    try {
                         await UsersRepository.adminDeleteTransaction(id);
                          swal.fire(
                                "Deleted!",
                                'Transaction deleted successfully',
                                "success"
                            );
                            this.refresh();
                    } catch (error) {
                         swal(
                                "Failed!",
                                "There was something wrong.",
                                "warning"
                            );
                    }
                }
            });

        },
        transactionModal() {
            $("#modal-transactions").modal("show");
        },
        refresh() {
            this.$emit("refresh");
        },
        async createTransaction() {
            try {
                if (
                    !this.receiver_account ||
                    !this.trans_option ||
                    !this.user.account ||
                    !this.receiver_name ||
                    !this.description ||
                    !this.bank_name ||
                    !this.is_credit ||
                    !this.currency ||
                    !this.amount ||
                    !this.date
                ) {
                    return toast.fire({
                        type: "error",
                        title: "Ensure all fields are filled"
                    });
                }
                this.processing = true;
                var data = {
                    is_credit: this.is_credit,
                    currency: this.currency,
                    user_id: this.user.id,
                    sender_name: `${this.user.first_name} ${this.user.last_name}`,
                    sender_account: this.user.account,
                    trans_option: this.trans_option,
                    date: this.date,
                    description: this.description,
                    receiver_name: this.receiver_name,
                    bank_name: this.bank_name,
                    receiver_account: this.receiver_account,
                    amount: this.amount
                };
                await UsersRepository.adminCreateTransaction(data);
                this.refresh();
                $("#modal-transactions").modal("hide");
                this.processing = false;
                toast.fire({
                    type: "success",
                    title: "Account status updated"
                });
            } catch (error) {
                console.log(error);
                this.processing = false;
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
            }
        }
    }
};
</script>
